import { ChartType } from "../../models/chart_model";
import { getMonthFromDate, getDayFromDate } from "../../extensions/date";

export const R_CHART_TYPES = [
  { value: ChartType.Bar, label: "Standard Bar", stackId: undefined },
  { value: ChartType.Bar, label: "Stacked Bar", stackId: "a" },
  { value: ChartType.Line, label: "Line" },
];

export const R_AREA_CHART_TYPES = {
  value: ChartType.Area,
  label: "Area",
  stackId: "stacked",
};

export const T_CHART_TYPES = [{ value: ChartType.Line, label: "Line" }];

// export function getLast7DaysDateRange() {
//   // Create dates using local timezone
//   const today = new Date();
//   today.setHours(0, 0, 0, 0); // Set to beginning of day in local timezone

//   const sevenDaysAgo = new Date(today);
//   sevenDaysAgo.setDate(today.getDate() - 7);

//   // Return the objects directly
//   return {
//     startDate: sevenDaysAgo,
//     endDate: today,
//     key: "selection",
//   };
// }

export function getLast7DaysDateRange() {
  // Get current date
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Find last Sunday (end of previous week)
  const lastSunday = new Date(today);

  // Find last Monday (start of previous week)
  const lastMonday = new Date(lastSunday);
  lastMonday.setDate(lastSunday.getDate() - 6);

  // Return the previous week date range
  return {
    startDate: lastMonday,
    endDate: lastSunday,
    key: "selection",
  };
}

export function getPreviousWeekDateRange() {
  // Get current date
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Find last Sunday (end of previous week)
  const lastSunday = new Date(today);

  // Find last Monday (start of previous week)
  const lastMonday = new Date(lastSunday);
  lastMonday.setDate(lastSunday.getDate() - 6);

  // Find the week before the previous week
  const previousWeekSunday = new Date(lastMonday);
  previousWeekSunday.setDate(lastMonday.getDate() - 1); // Day before last Monday

  const previousWeekMonday = new Date(previousWeekSunday);
  previousWeekMonday.setDate(previousWeekSunday.getDate() - 3); // 7 days before previous week Sunday

  // Return the week before the previous week date range
  return {
    startDate: previousWeekMonday,
    endDate: previousWeekSunday,
    key: "selection",
  };
}

// NEW FUNCTION: Use this to format dates for API calls
export function formatDateForAPI(date: Date): string {
  // Format date in YYYY-MM-DD format preserving local date
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Function to fill missing date blocks for Rajasthan data
// Usage example:
// const filledData = fillMissingRajasthanData(
//   originalData, 
//   "2024-01-01", 
//   "2024-01-31", 
//   ["JVVNL", "AVVNL", "JDVVNL"] // optional discoms array
// );
export function fillMissingRajasthanData(
  data: any[],
  startDate: string,
  endDate: string,
  discoms: string[] = []
): any[] {
  // Generate all dates in the range
  const allDates: string[] = [];
  const currentDate = new Date(startDate);
  const endDateObj = new Date(endDate);
  
  while (currentDate <= endDateObj) {
    allDates.push(currentDate.toISOString().split('T')[0]);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  // Generate all possible combinations
  const allCombinations: Array<{ date: string; block: number; discom?: string }> = [];
  
  allDates.forEach(date => {
    for (let block = 1; block <= 96; block++) {
      if (discoms.length > 0) {
        discoms.forEach(discom => {
          allCombinations.push({ date, block, discom });
        });
      } else {
        allCombinations.push({ date, block });
      }
    }
  });

  // Create a map of existing data
  const existingDataMap = new Map<string, any>();
  data.forEach(item => {
    const key = discoms.length > 0 
      ? `${item.date}-${item.block}-${item.discom || ''}`
      : `${item.date}-${item.block}`;
    existingDataMap.set(key, item);
  });

  // Fill missing data
  const filledData: any[] = [];
  
  allCombinations.forEach(combo => {
    const key = discoms.length > 0 
      ? `${combo.date}-${combo.block}-${combo.discom || ''}`
      : `${combo.date}-${combo.block}`;
    
    const existingItem = existingDataMap.get(key);
    
    if (existingItem) {
      filledData.push(existingItem);
    } else {
      // Create zero-filled item
      const newItem = {
        date: combo.date,
        block: combo.block,
        month: getMonthFromDate(combo.date),
        dates: `${startDate} to ${endDate}`,
        dateIndex: getDayFromDate(combo.date) + " Day",
        // Set all numeric fields to 0
        drawal_mw: 0,
        schedule_mw: 0,
        load_shedding_mw: 0,
        total_mw: 0,
        drawal_mwh: 0,
        schedule_mwh: 0,
        load_shedding_mwh: 0,
        total_mwh: 0,
        drawal_lu: 0,
        schedule_lu: 0,
        load_shedding_lu: 0,
        total_lu: 0,
        ...(combo.discom && { discom: combo.discom }),
      };
      
      filledData.push(newItem);
    }
  });

  return filledData;
}
